import { onboardingStages, OnboardingStage } from "@/constants/onboarding";

export type OnboardingProgress = {
    version: 1;
    stage: OnboardingStage;
};

const isOnboardingProgress = (value: unknown): value is OnboardingProgress =>
    typeof value === "object" &&
    value !== null &&
    "version" in value &&
    value.version === 1 &&
    "stage" in value &&
    onboardingStages.includes(value.stage as OnboardingStage);

export const onboardingProgressStorageKey = (email: string): string =>
    `onboarding:v1:${email.toLowerCase()}`;

export const loadOnboardingProgress = (
    storageKey: string,
): OnboardingProgress | null => {
    try {
        const saved = localStorage.getItem(storageKey);
        if (!saved) return null;

        const parsed: unknown = JSON.parse(saved);
        return isOnboardingProgress(parsed) ? parsed : null;
    } catch (error) {
        console.warn("Unable to restore onboarding progress.", error);
        return null;
    }
};

export const saveOnboardingProgress = (
    storageKey: string,
    progress: OnboardingProgress,
): void => {
    localStorage.setItem(storageKey, JSON.stringify(progress));
};
